function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40.5C31.0457 40.5 40 31.5457 40 20.5C40 9.45431 31.0457 0.5 20 0.5C8.95431 0.5 0 9.45431 0 20.5C0 31.5457 8.95431 40.5 20 40.5Z",
  fill: "#150847"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7338 16.512C27.09 16.512 29 18.4231 29 20.7805V25.2314C29 27.5889 27.09 29.5 24.7338 29.5H14.7564C12.8897 29.5 11.3729 28.0011 11.3428 26.1406L11.3423 26.0841H23.2017C24.9008 26.0841 26.2781 24.706 26.2781 23.006C26.2781 21.306 24.9008 19.9279 23.2017 19.9279H17.6136C16.7654 19.9279 16.0778 19.2399 16.0778 18.3912V16.512H24.7338ZM25.201 11.5C27.0676 11.5 28.5844 12.9989 28.6146 14.8594L28.615 14.9159H16.7983C15.0992 14.9159 13.7219 16.294 13.7219 17.994C13.7219 19.694 15.0992 21.0721 16.7983 21.0721H22.0877C23.1009 21.0721 23.9222 21.8939 23.9222 22.9076V24.488H15.2662C12.91 24.488 11 22.5769 11 20.2195V15.7686C11 13.4111 12.91 11.5 15.2662 11.5H25.201Z",
  fill: "url(#paint0_linear_185_513)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_185_513",
  x1: 20,
  y1: 11.7905,
  x2: 20,
  y2: 29.2083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCDEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C7DFF"
})));

function SvgSrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrs);
export default __webpack_public_path__ + "static/media/srs.d6041cdb.svg";
export { ForwardRef as ReactComponent };